import type { AccessScope } from '../../auth';
import { featureAccessProjectionStatus } from '../../feature-access-projection';

type ContractorManagementScope = Readonly<{
  persona: AccessScope['persona'];
  capabilities: readonly string[];
  resource: AccessScope['resource'];
  featureAccess?: unknown;
  developerReadOnly?: boolean;
}>;

export function canManageContractorDirectory(scope: ContractorManagementScope) {
  const projected = featureAccessProjectionStatus(scope.featureAccess);
  if (projected.kind === 'malformed') return false;
  if (projected.kind === 'enforced')
    return !scope.developerReadOnly && projected.features.has('contractor-management') &&
      scope.resource.kind === 'site' && /^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/u.test(scope.resource.siteId);
  return (
    ['site-manager', 'safety-manager'].includes(scope.persona) &&
    scope.capabilities.includes('site:manage') &&
    scope.resource.kind === 'site' &&
    /^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/u.test(scope.resource.siteId)
  );
}

export function canViewContractorDirectory(scope: ContractorManagementScope) {
  const projected = featureAccessProjectionStatus(scope.featureAccess);
  if (projected.kind === 'malformed') return false;
  if (projected.kind === 'enforced')
    return projected.features.has('contractor-management') && scope.resource.kind === 'site' &&
      /^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/u.test(scope.resource.siteId);
  return canManageContractorDirectory(scope);
}
